import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Phase 3 (Feb 2026): JWT lives in HttpOnly cookie `to_token`.
// The readable `to_csrf` cookie must be echoed in `X-CSRF-Token`
// on every state-changing request (double-submit CSRF pattern).
const api = axios.create({ baseURL: API, withCredentials: true });

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const prefix = `${name}=`;
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (const p of parts) {
    if (p.startsWith(prefix)) return decodeURIComponent(p.slice(prefix.length));
  }
  return null;
}

const SAFE_METHODS = new Set(["get", "head", "options"]);

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const method = (config.method || "get").toLowerCase();
  if (!SAFE_METHODS.has(method)) {
    const csrf = readCookie("to_csrf");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

// Best-effort clean-up of the pre-Phase-3 localStorage token (Feb 2026).
// This runs once on import so any lingering key from a mid-session user's
// prior tab is scrubbed from disk — belt-and-braces after the migration
// shim was removed.
try {
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem("to_token");
  }
} catch (_) { /* ignore quota / private-mode errors */ }

export default api;
